/* ============================================================
   Sticky add-to-cart bar (CRO)
   - Reveals only after the in-page Add-to-Cart scrolls above the viewport
   - Hides again when scrolled back up, or when the footer is in view
   - Triggers the real [data-add-to-cart] so variant + cart-drawer logic stays single-sourced
   - Mirrors [data-product-price] and the button's sold-out state
   - Multi-variant products open a <dialog> size sheet (top layer, above any overlay).
     Chips proxy-click the real [data-variant-input]s; sheet events are delegated on
     `document` so they survive any re-render and any number of switches.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) { return; }

    var form = document.querySelector('.product-single__form');
    var mainBtn = (form || document).querySelector('[data-add-to-cart]');
    if (!mainBtn) { return; }

    var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
    var stickyTxt = bar.querySelector('[data-sticky-atc-text]');
    var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    var mainPrice = document.querySelector('[data-product-price]');
    var mainBtnTxt = mainBtn.querySelector('[data-add-to-cart-text]');
    var defaultLabelHTML = stickyTxt ? stickyTxt.innerHTML : '';

    var sheet = document.querySelector('[data-sticky-atc-sheet]');
    var useSheet = !!sheet && document.querySelectorAll('[data-variant-input]').length > 0;
    if (sheet && !useSheet && sheet.parentNode) { sheet.parentNode.removeChild(sheet); sheet = null; }

    function getSheet() { return document.querySelector('[data-sticky-atc-sheet]'); }
    function attrEsc(s) { return String(s).replace(/(["\\])/g, '\\$1'); }
    function radioFor(name, value) {
      return document.querySelector(
        'input[data-variant-input][name="' + attrEsc(name) + '"][value="' + attrEsc(value) + '"]'
      );
    }

    function syncChips() {
      if (!useSheet) { return; }
      var chips = document.querySelectorAll('[data-sticky-atc-chip]'); // bar + sheet stay in sync
      for (var i = 0; i < chips.length; i++) {
        var chip = chips[i];
        var r = radioFor(chip.getAttribute('data-option-name'), chip.getAttribute('data-value'));
        chip.classList.toggle('is-selected', !!(r && r.checked));
        chip.disabled = !!(r && (r.disabled || /\b(disabled|unavailable|sold)\b/.test(r.className)));
      }
    }

    var lastFocus = null;

    function openSheet() {
      if (!useSheet) { if (!mainBtn.hasAttribute('disabled')) { mainBtn.click(); } return; }
      var s = getSheet();
      if (!s) { return; }
      lastFocus = document.activeElement;
      syncChips();
      if (typeof s.showModal === 'function') {
        if (!s.open) { try { s.showModal(); } catch (e) { s.setAttribute('open', ''); } }
      } else {
        s.setAttribute('open', '');
        s.style.zIndex = '2147483647';
      }
      void s.offsetHeight; // reflow so the slide-up runs from translateY(100%)
      s.classList.add('is-open');
    }

    function closeSheet() {
      var s = getSheet();
      if (!s) { return; }
      s.classList.remove('is-open');
      window.setTimeout(function () {
        if (typeof s.close === 'function' && s.open) { try { s.close(); } catch (e) {} }
        else { s.removeAttribute('open'); }
      }, 300);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }

    // Bar button: open the size sheet for multi-variant, otherwise add directly.
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (mainBtn.hasAttribute('disabled')) { return; }
        // Desktop shows the size chips inline on the bar → add directly.
        // Mobile opens the space-saving sheet.
        var desktop = window.matchMedia('(min-width: 769px)').matches;
        if (useSheet && !desktop) { openSheet(); } else { mainBtn.click(); }
      });
    }

    if (useSheet) {
      // Delegated on document → robust to re-renders and repeated switching.
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) { return; }

        var chip = t.closest('[data-sticky-atc-chip]');
        if (chip) {
          if (chip.disabled) { return; }
          var r = radioFor(chip.getAttribute('data-option-name'), chip.getAttribute('data-value'));
          if (r && !r.checked) { r.click(); } // programmatic click still fires on the (modal-inert) radio
          syncChips();
          return;
        }
        if (t.closest('[data-sticky-atc-confirm]')) {
          if (!mainBtn.hasAttribute('disabled')) { mainBtn.click(); }
          closeSheet();
          return;
        }
        if (t.closest('[data-sticky-atc-close]')) { closeSheet(); }
      });

      var sheetEl = getSheet();
      if (sheetEl) {
        sheetEl.addEventListener('cancel', function (e) { e.preventDefault(); closeSheet(); }); // Escape
        sheetEl.addEventListener('click', function (e) { if (e.target === sheetEl) { closeSheet(); } }); // backdrop / light dismiss
      }
    }

    // --- Mirror price + sold-out state (keeps the responsive label otherwise) ---
    function sync() {
      if (stickyPrice && mainPrice) { stickyPrice.innerHTML = mainPrice.innerHTML; }
      if (stickyBtn) {
        var disabled = mainBtn.hasAttribute('disabled');
        stickyBtn.disabled = disabled;
        if (stickyTxt) {
          if (disabled && mainBtnTxt) { stickyTxt.textContent = mainBtnTxt.textContent.trim(); }
          else { stickyTxt.innerHTML = defaultLabelHTML; }
        }
      }
      syncChips();
    }
    sync();

    if (mainPrice) {
      new MutationObserver(sync).observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }
    new MutationObserver(sync).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });

    // --- Reveal logic (rAF-throttled scroll compute) ---
    var footer = document.querySelector('.site-footer, [data-section-type="footer"], footer');
    var ticking = false;

    function compute() {
      ticking = false;
      var passed = mainBtn.getBoundingClientRect().bottom < 0;
      var footerShown = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = passed && !footerShown;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(compute); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    compute();
  });
})();
